import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'offers'
const verb = 'get'

export default class OspreyOffersGetThumbnails extends BaseAction {
    constructor(dataKey) {
        const id = 'c67676d7-d909-4e3e-bd5c-cf686293cc9f'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    getThumbnails(params) {
        this.params = Object.assign({
            fields: 'id,thumbnailUrl',
            pc: 8,
            archived: false
        }, params)

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/offers/offers-get-thumbnails.js